import { Type } from 'class-transformer';
import { VendorAccountResultDto } from './vendor-account-result-dto';

export class ManageVendorAccountsResultDto {
    @Type(() => VendorAccountResultDto)
    vendorAccounts: Array<VendorAccountResultDto> = [];
    allowAdd: boolean; // 	NOTE: Indicates if new vendor accounts can be added
}
